import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import Tooltip, { Orientation } from '@dojo/widgets/tooltip';
import { publish, subscribe } from 'pub-sub';
import { userstore } from 'lcc-state';
import css from '../css/lptool.m.css';
let LPTool = class LPTool extends I18nThemed {
    _tooltipShowing = false;
    _disabled = false;
    _inited = false;
    _subs = [];
    onDetach() {
        this._subs.forEach((h) => {
            h.destroy();
        });
    }
    render() {
        const { classes = [], name, element = 'li', icon = '', iconcomplete, tooltip, action, location = '', disablewhen, enablewhen } = this.properties;
        const { get, path } = userstore;
        const { complete = false, extra, hide } = get(path('toolstate', action)) || {
            complete: false,
            extra: undefined,
            hide: undefined
        };
        const { _tooltipShowing, _disabled } = this;
        let useicon = complete && iconcomplete ? iconcomplete : icon;
        if (useicon === 'clock' && hide) {
            useicon = 'countdown';
        }
        const svgpath = `${window.hcstatic.portal_cdn}/js/images/iconsheet.svg#${useicon}`;
        const matches = location.match(/^\/?([\w-]*)/) || [];
        const active = action === matches[1];
        if (!this._inited) {
            disablewhen &&
                this._subs.push(subscribe(disablewhen, () => {
                    this._disabled = true;
                    this.invalidate();
                }));
            enablewhen &&
                this._subs.push(subscribe(enablewhen, () => {
                    this._disabled = false;
                    this.invalidate();
                }));
            this._inited = true;
        }
        return v(element, {
            key: name,
            role: 'menuitem',
            tabIndex: 0,
            classes: [
                this.theme(css.tool),
                complete ? this.theme(css.completed) : '',
                active ? this.theme(css.active) : _disabled ? this.theme(css.disabled) : '',
                ...classes
            ],
            xqa: `lptool ${name}`,
            'aria-label': tooltip,
            onclick: (evt) => {
                evt && evt.stopPropagation();
                if (!_disabled) {
                    const act = `site/${action || name}`;
                    publish(act);
                }
            },
            onmouseover: () => {
                if (!this._tooltipShowing) {
                    this._tooltipShowing = true;
                    this.invalidate();
                }
            },
            onmouseout: () => {
                this._tooltipShowing = false;
                this.invalidate();
            },
            onfocus: () => {
            }
        }, [
            w(Tooltip, {
                key: `${name}-tt`,
                orientation: Orientation.bottom,
                open: _tooltipShowing
            }, [
                {
                    content: tooltip,
                    trigger: [
                        v('svg', { 'xmlns:xlink': 'http://www.w3.org/1999/xlink', role: 'img' }, [
                            v('use', { href: svgpath, 'xlink:href': svgpath })
                        ]),
                        complete ? v('div', { classes: [this.theme(css.complete)] }, ['\u2713']) : null,
                        extra && !hide ? v('div', { classes: [this.theme(css.extra)] }, [extra]) : null
                    ]
                }
            ])
        ]);
    }
};
LPTool = __decorate([
    theme(css),
    storeInject({
        name: 'user-state',
        paths: [['toolstate'], ['location']],
        getProperties: (store) => {
            const { get, path } = store;
            return {
                toolstate: get(path('toolstate')),
                location: get(path('location'))
            };
        }
    })
], LPTool);
export { LPTool };
export default LPTool;
